// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cDBug","title":"styles_title__2obnZ"};